import { render } from "./AuthorizedLayout.vue?vue&type=template&id=fe9b32e0&ts=true"
import script from "./AuthorizedLayout.vue?vue&type=script&lang=ts"
export * from "./AuthorizedLayout.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__